import { render } from "./StudyDataDashboard.vue?vue&type=template&id=19b80ce1&scoped=true"
import script from "./StudyDataDashboard.vue?vue&type=script&lang=js"
export * from "./StudyDataDashboard.vue?vue&type=script&lang=js"

import "./StudyDataDashboard.vue?vue&type=style&index=0&id=19b80ce1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19b80ce1"]])

export default __exports__